import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const ReturnsImportWrapper = ({ newReturnsCount, updatedReturnsCount, storeName }) => {
  return (
    <FormattedMessage
      defaultMessage='Imported <a>{newReturnsCount} new returns</a> and updated <b>{updatedReturnsCount} existing returns</b> for <c>{storeName}</c>.'
      description='Returns imported alert'
      id='A9L+N1'
      values={{
        newReturnsCount,
        updatedReturnsCount,
        storeName,
        a: (chunks) => <b>{chunks}</b>,
        b: (chunks) => <b>{chunks}</b>,
        c: (chunks) => <b>{chunks}</b>,
      }}
    />
  );
};

ReturnsImportWrapper.propTypes = {
  newReturnsCount: PropTypes.number.isRequired,
  updatedReturnsCount: PropTypes.number.isRequired,
  storeName: PropTypes.string.isRequired,
};

export const ReturnsImport = injectIntl(ReturnsImportWrapper);
